import { Component, OnInit, Input, Output, OnChanges, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { Router } from '@angular/router';
import { scaleIn } from '../../shared/animations/scale.animation';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-navigation-modal',
  templateUrl: './navigation-modal.component.html',
  styleUrls: ['./navigation-modal.component.css'],
  animations: [scaleIn]
})
export class NavigationModalComponent implements OnInit {

  @Input() closable = true;
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private dataService: DataService) { }

  ngOnInit() {
  }

  close() {
    setTimeout(() => {
      this.document.body.style.overflow = 'visible';
      this.visible = false;
      this.visibleChange.emit(this.visible);
    }, 250);
  }

  liveStream() {
    this.router.navigate(['/concert']).then((completed) => {
      this.dataService.sendData(true); 
    })
  }

  goto(url: string): void {
    this.router.navigate([url]).then((completed) => {
      setTimeout(() => {
        this.close();
      }, 500);
    });
  }
}
